var map = {
	"./Img_1.png": 7131,
	"./Img_2.png": 8448,
	"./Img_3.png": 3273,
	"./Img_4.png": 9014,
	"./Img_5.png": 7103,
	"./Img_6.png": 7188,
	"./Img_7.png": 9693,
	"./Img_8.png": 5834,
	"./bud-xl.png": 5430,
	"./cal-mag.png": 3252,
	"./cocos-a.png": 8963,
	"./cocos-b.png": 3208,
	"./default.png": 2281,
	"./diamond-nectar.png": 5530,
	"./hydroguard.png": 7001,
	"./hydroplex.png": 7191,
	"./liquid-karma.png": 7219,
	"./nitrogen-boost.png": 2272,
	"./paleo-bloom.png": 9227,
	"./power-si.png": 20,
	"./roots-gold.png": 1818,
	"./sea-green.png": 1965,
	"./sweet-raw.png": 483,
	"./sweet.png": 3958,
	"./top-shooter.png": 6736,
	"./true-blooms.png": 1059,
	"./vitamino.png": 4021
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8599;